export const botsToolGroupIcon = {
  icon: 'robot',
} as const;

export const promptsToolGroupIcon = {
  icon: 'square-terminal',
} as const;

export const aiModelsToolGroupIcon = {
  icon: 'hexagon-nodes',
} as const;
